// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"b985293b","209":"b92ce355","239":"97f940fe","375":"e6736380","457":"05f0af6b","551":"53529a62","570":"e58fc349","842":"fb887f9d","851":"212e0de2"}[chunkId] + ".chunk.js";
};